import React from "react"

import ProductRatings from "components/article/product-rating"
import {
  Container,
  CardContainer,
  ButtonElement,
  CardImage,
  ImageWrapper,
  Category,
  Headline,
  Subheadline,
} from "./styles"

const Card = ({ item }) => {
  const { headlineCard, subheadline, image, category, url, shopifyProductVariant } = item

  const subheadlineText = subheadline.childMarkdownRemark?.html.replace(/<\/?[^>]+(>|$)/g, "")
  const shopifyProduct = shopifyProductVariant?.product

  return (
    <Container>
      <CardContainer>
        <ImageWrapper>
          <CardImage
            baseUrl={image[0]?.secure_url}
            images={[
              {
                screenSize: 768,
                transforms: "c_fill,g_auto,w_169,h_169,q_auto,f_auto,fl_lossy",
              },
              {
                transforms: "c_fill,g_auto,w_218,h_220,q_auto,f_auto,fl_lossy",
              },
            ]}
            lazy
          />
        </ImageWrapper>
        <Category>{category}</Category>
        <Headline>{headlineCard}</Headline>
        <Subheadline>{subheadlineText}</Subheadline>
      </CardContainer>
      <ProductRatings review={shopifyProduct?.review} />
      <ButtonElement type="button" value="SHOP NOW" onClick={() => (window.location.href = url)} />
    </Container>
  )
}

export default Card
